const INTERACTIVE_NODE_NAMES = {
  a: 'ANCHOR',
  audio: 'AUDIO',
  button: 'BUTTON',
  details: 'DETAILS',
  embed: 'EMBED',
  iframe: 'IFRAME',
  img: 'IMG',
  input: 'INPUT',
  label: 'LABEL',
  select: 'SELECT',
  textarea: 'TEXTAREA',
  video: 'VIDEO',
}

/**
 * Returns if the node provided is interactive. Interactive elements
 * are a subset of HTML elements that support interaction.
 */
function isChildInteractive(node: ChildNode) {
  if (!node || !node.nodeName) {
    return false
  }

  return Object.hasOwnProperty.call(
    INTERACTIVE_NODE_NAMES,
    node.nodeName.toLowerCase(),
  )
}

/**
 * Returns an element that supports interactivity, if can be found.
 * Searches to a maximum of 5 levels deep.
 */
export function getInteractiveChild(
  element: HTMLElement | null,
): ChildNode | undefined {
  if (!element) {
    return
  }

  const MAX_DEPTH = 5

  // breadth-first search
  const stack: { node: ChildNode; level: number }[] = [
    { node: element, level: 0 },
  ]

  while (stack.length) {
    const item = stack.pop()

    if (!item) continue

    const { node, level } = item

    if (isChildInteractive(node)) {
      return node
    }

    for (const child of Array.from(node.childNodes)) {
      if (level + 1 > MAX_DEPTH) {
        continue
      }

      stack.unshift({
        node: child,
        level: level + 1,
      })
    }
  }

  return
}
